import { Button, Grid, TextField, DialogActions } from '@mui/material';
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from './styles.module.css';
import CloseIcon from '@mui/icons-material/Close';
import ShopService from 'services/ShopService';
import NumberField from 'components/library/NumberField';
// import AlertHelper from 'components/utils/Alert/AlertHelper';

export default function AddShopDialog(props) {
  const { toggleAddTab, updateShops } = props;
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const { t } = useTranslation("common");
  const handleAddShop = async () => {
    const data = {
      shop_name: name,
      mobile_no: phone,
    };
    await ShopService.setShop(data);
    updateShops();
    toggleAddTab();
  };
  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{t("Create new shop", "Create new shop")}</h2>
          <CloseIcon onClick={toggleAddTab} />
        </div>
        <div className={styles.inputSec}>
          <Grid container className={styles.inputRow} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
              <h3 className={styles.inputLabel}>{t("Shop Name", "Shop Name")}</h3>
            </Grid>
            <Grid item xs={8} sm={8}>
              <TextField
                label={t("Shop Name", "Shop Name")}
                variant="outlined"
                size="small"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid container className={styles.inputRow} alignItems="center">
            <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
              <h3 className={styles.inputLabel}>{t("Shop Mobile", "Shop Mobile")}</h3>
            </Grid>
            <Grid item xs={8} sm={8}>
              <NumberField
                label={t("Shop Mobile", "Shop Mobile")}
                className={styles.numberInput}
                name="phone"
                value={phone}
                InputProps={{ inputProps: { maxLength: 15 } }}
                onChange={(e) => setPhone(e.target.value.slice(0, 15))}
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.footSec}>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={toggleAddTab}
              className={styles.closeBtn}
            >
              {t("Close", "Close")}
            </Button>
            <Button
              variant="contained"
              size="small"
              color="primary"
              style={{ backgroundColor: '#00a65a' }}
              disabled={name === '' || phone === ''}
              onClick={handleAddShop}
            >
              {t("Create shop", "Create shop")}
            </Button>
          </DialogActions>
        </div>
      </div>
    </div>
  );
}
